import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../styles/boat/BoatCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRulerHorizontal, faUsers, faBed, faToilet, faChevronLeft, faChevronRight, faStar } from '@fortawesome/free-solid-svg-icons';
import BoatLeadModal from './BoatLeadModal';
import BoatImageGallery from './BoatImageGallery';
import { generateBoatUrl } from '../../utils/stringUtils';

const BoatCard = ({ boat }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);

  const mainImage = boat.main_image;
  const galleryImages = boat.gallery_images && boat.gallery_images.length > 0
    ? boat.gallery_images
        .map(img => img.image)
        .filter(imgUrl => imgUrl !== mainImage)
    : [];
  const images = [mainImage, ...galleryImages].filter(Boolean);
  
  const handleNavigateToBoat = () => {
    const boatUrl = generateBoatUrl(boat);
    navigate(boatUrl, { state: { from: location } });
  };

  const handleReviewScoreClick = (e) => {
    e.stopPropagation();
    const boatUrl = generateBoatUrl(boat);
    navigate(boatUrl, { 
      state: { 
        from: location,
        scrollToReviews: true 
      } 
    });
  };

  const handleQuickQuote = (e) => {
    e.stopPropagation();
    setIsLeadModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsLeadModalOpen(false);
  };

  return (
    <div className="boat-card">
      <div className="boat-card__image-section">

        {boat.featured && (
          <div className="boat-card__featured-badge">
            <FontAwesomeIcon icon={faStar} className="boat-card__featured-icon" />
            <span>FEATURED</span>
          </div>
        )}
        <BoatImageGallery
          images={images}
          alt={boat.name}
          onMainImageClick={handleNavigateToBoat}
        />
      </div>
      <div className="boat-card__content">
        <div className="boat-card__header-info">
          <span className="boat-card__category">{boat.category?.name?.toUpperCase()}</span>
          {boat.average_rating && boat.average_rating !== "0.0" && (
            <div className="boat-card__review-score" onClick={handleReviewScoreClick}>
              <FontAwesomeIcon icon={faStar} className="boat-card__review-star" />
              <span className="boat-card__review-rating">{boat.average_rating}</span>
            </div>
          )}
        </div>
        <div className="boat-card__header-row">
          <div className="boat-card__header-name" onClick={handleNavigateToBoat}>
            <h2 className="boat-card__name">{boat.name}</h2>
            {boat.code && (
              <div className="boat-card__code">{boat.code}</div>
            )}
          </div>
          
          {(boat.discount_price || boat.price) ? (
            <div className="boat-card__header-price">
              <span className="boat-card__header-price-from">FROM</span>
              <div className="boat-card__header-price-row">
                {boat.discount_price ? (
                  <>
                    <span className="boat-card__header-price-discount">${boat.discount_price.toLocaleString()}</span>
                    {boat.price && (
                      <span className="boat-card__header-price-regular">${boat.price.toLocaleString()}</span>
                    )}
                  </>
                ) : (
                  <span className="boat-card__header-price-main">${boat.price.toLocaleString()}</span>
                )}
              </div>
              {boat.duration_hours && (
                <span className="boat-card__header-price-hours">
                  {boat.duration_hours} Hours
                </span>
              )}
            </div>
          ) : (
            <div className="boat-card__header-price">
              <span className="boat-card__header-price-ask">Ask for price</span>
            </div>
          )}
        </div>
        <div className="boat-card__specs">
          {boat.length ? (
            <span title="Length">
              <FontAwesomeIcon icon={faRulerHorizontal} className="boat-card__spec-icon" />
              {boat.length} ft.
            </span>
          ) : null}
          {boat.capacity ? (
            <span title="Capacity">
              <FontAwesomeIcon icon={faUsers} className="boat-card__spec-icon" />
              {boat.capacity} ppl.
            </span>
          ) : null}
          {boat.staterooms ? (
            <span title="Staterooms">
              <FontAwesomeIcon icon={faBed} className="boat-card__spec-icon" />
              {boat.staterooms}
            </span>
          ) : null}
          {boat.bathrooms ? (
            <span title="Bathrooms">
              <FontAwesomeIcon icon={faToilet} className="boat-card__spec-icon" />
              {boat.bathrooms}
            </span>
          ) : null}
        </div>
        <div className="boat-card__actions">
          <button className="button" onClick={handleQuickQuote}>QUICK QUOTE</button>
          <button className="button button--outline" onClick={handleNavigateToBoat}>VIEW MORE</button>
        </div>
      </div>

      {isLeadModalOpen && <BoatLeadModal onClose={handleCloseModal} boat={boat} />}
    </div>
  );
};

export default BoatCard;